export type CityMeta = {
  key: string;
  name: string;
  cover: string;
  intro: string;
  seoTitle?: string;
  seoDescription?: string;
};

export const CITY_DATA: Record<string, CityMeta> = {
  tokyo: {
    key: 'tokyo',
    name: '东京',
    cover: '/assets/images/destinations/tokyo.jpg',
    intro:
      '东京是全世界最著名的现代大都会，每年已有超过一千万旅客到访。旧与新并存的风情会吸引更多人朝圣。',
    seoTitle: '东京 - 旅行指南与推荐 | CubeMeet',
    seoDescription: '探索东京的最佳行程、景点与旅行计划。发现当地美食、地标与实用旅行建议。',
  },
  osaka: {
    key: 'osaka',
    name: '大阪',
    cover: '/assets/images/destinations/osaka.jpg',
    intro: '大阪以美食和热闹街区著称，是亲民且充满活力的城市。',
    seoTitle: '大阪 - 旅行指南与推荐 | CubeMeet',
    seoDescription: '发现大阪的必吃美食、购物与文化体验。',
  },
  kyoto: {
    key: 'kyoto',
    name: '京都',
    cover: '/assets/images/destinations/kyoto.jpg',
    intro: '京都保留了日本古都的传统寺庙与庭院，是感受日本历史文化的首选。',
    seoTitle: '京都 - 旅行指南与推荐 | CubeMeet',
    seoDescription: '京都的寺庙、和服体验、季节性景观与文化路线推荐。',
  },
  fuji: {
    key: 'fuji',
    name: '富士山',
    cover: '/assets/images/destinations/fuji.jpg',
    intro: '富士山是日本的象征，从不同角度欣赏都别有一番风味。',
    seoTitle: '富士山 - 旅行指南与推荐 | CubeMeet',
    seoDescription: '计划你的富士山之旅，包含观景点与一日游建议。',
  },
  hongkong: {
    key: 'hongkong',
    name: '香港',
    cover: '/assets/images/destinations/hongkong.jpg',
    intro: '香港是东西文化交汇的国际都会，美食与购物皆闻名。',
    seoTitle: '香港 - 旅行指南与推荐 | CubeMeet',
    seoDescription: '香港的观光、岛屿一日游与地道美食推荐。',
  },
  taipei: {
    key: 'taipei',
    name: '台北',
    cover: '/assets/images/destinations/taibei.jpg',
    intro: '台北融合了传统夜市文化与现代城市氛围，适合短途旅行。',
    seoTitle: '台北 - 旅行指南与推荐 | CubeMeet',
    seoDescription: '台北美食、文化与周边短途行程建议。',
  },
  seoul: {
    key: 'seoul',
    name: '首爾',
    cover: '/assets/images/destinations/seoul.jpg',
    intro: '首爾是韓國的首都，集結歷史地標與現代購物與美食文化，是短途旅遊與城市漫遊的好選擇。',
    seoTitle: '首爾 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索首爾的景點、美食與行程建議。',
  },
  macau: {
    key: 'macau',
    name: '澳門',
    cover: '/assets/images/destinations/macau.jpg',
    intro: '澳門融合了葡式風情與粵港美食，是短途美食與文化之旅的好去處。',
    seoTitle: '澳門 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索澳門的必去景點、美食與一日遊行程建議。',
  },
  bangkok: {
    key: 'bangkok',
    name: '曼谷',
    cover: '/assets/images/destinations/bangkok.jpg',
    intro: '曼谷是泰國的首都，以活力十足的街市、寺廟與多樣美食聞名，適合短程停留與文化探索。',
    seoTitle: '曼谷 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索曼谷的景點、美食與行程建議。',
  },
  singapore: {
    key: 'singapore',
    name: '新加坡',
    cover: '/assets/images/destinations/singapore.jpg',
    intro: '新加坡是東南亞的花園城市，結合都市現代化與多元文化與美食，是短程探索與家庭旅遊常見目的地。',
    seoTitle: '新加坡 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索新加坡的景點、美食與行程建議。',
  },
  shanghai: {
    key: 'shanghai',
    name: '上海',
    cover: '/assets/images/destinations/shanghai.jpg',
    intro: '上海是中國的國際大都市，結合歷史建築與現代摩天大樓，是購物、美食與文化探索的熱門目的地。',
    seoTitle: '上海 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索上海的景點、外灘、城隍廟與在地美食指南。',
  },
  'kuala-lumpur': {
    key: 'kuala-lumpur',
    name: '吉隆坡',
    cover: '/assets/images/destinations/Kuala-Lumpur.jpg',
    intro: '吉隆坡是馬來西亞的首都，以摩天大樓與多元美食聞名，是探索馬來西亞文化與購物的好起點。',
    seoTitle: '吉隆坡 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索吉隆坡的景點、美食與行程建議。',
  },
  beijing: {
    key: 'beijing',
    name: '北京',
    cover: '/assets/images/destinations/beijing.jpg',
    intro: '北京是中國的首都，擁有豐富的歷史文化遺產與地標（如故宮、天安門與長城），也是美食與博物館的重要目的地。',
    seoTitle: '北京 - 旅行指南與推薦 | CubeMeet',
    seoDescription: '探索北京的景點、文化遺產與在地美食指南。',
  },
};

// tokens used to match city names inside JSONB fields or free text.
// include Traditional Chinese, Simplified Chinese and English variants (English matching is case-insensitive via ilike)
export const CITY_MATCH_TOKENS: Record<string, string[]> = {
  tokyo: ['Tokyo', '东京', '東京', 'tokyo'],
  osaka: ['Osaka', '大阪', 'osaka'],
  kyoto: ['Kyoto', '京都', 'kyoto'],
  hongkong: ['Hong Kong', '香港', '香港', 'hong kong', 'hongkong'],
  taipei: ['Taipei', '台北', '臺北', 'taipei'],
  fuji: ['Fuji', '富士山', '富士', 'fuji'],
  macau: ['Macau', '澳門', '澳门', 'macau'],
  seoul: ['Seoul', '首爾', '首尔', 'seoul'],
  bangkok: ['Bangkok', '曼谷', 'bangkok'],
  singapore: ['Singapore', '新加坡', 'singapore'],
  shanghai: ['Shanghai', '上海', 'shanghai', '上海市'],
  'kuala-lumpur': ['Kuala Lumpur', '吉隆坡', '吉隆坡', 'kuala lumpur', 'kuala-lumpur', 'kualalumpur'],
  beijing: ['Beijing', '北京', '北京市', 'beijing'],
};
